export default function isElement(obj) {
	return Object.prototype.toString.call(obj).startsWith('[object HTML');
}
